import { render, staticRenderFns } from "./SquadView.vue?vue&type=template&id=616fba76&scoped=true"
import script from "./SquadView.vue?vue&type=script&lang=js"
export * from "./SquadView.vue?vue&type=script&lang=js"
import style0 from "./SquadView.vue?vue&type=style&index=0&id=616fba76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616fba76",
  null
  
)

export default component.exports